import { useTranslation } from 'react-i18next';

/** Where the credit points. Kept here so every placement links to the same place. */
const APEXIUM_URL = 'https://apexiumsystems.com';

/**
 * The Apexium credit, linking to apexiumsystems.com. It belongs on every screen,
 * so it lives here rather than being retyped per page: the shell renders it once
 * in the sidebar on desktop and once at the foot of the content on a phone, and
 * the screens that sit outside the shell (login, recuperar, first-código) render
 * it themselves.
 */
export function PoweredByApexium({
  tone = 'light',
  className = '',
}: {
  /** `dark` sits on the navy brand surface, `light` on the grey app surface. */
  tone?: 'light' | 'dark';
  className?: string;
}) {
  const { t } = useTranslation();
  const dark = tone === 'dark';

  return (
    <a
      href={APEXIUM_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={`flex items-center justify-center gap-2.5 transition-opacity hover:opacity-80 ${className}`}
    >
      <span className={`text-[12px] ${dark ? 'text-[#8e9bd6]' : 'text-[#8a90a0]'}`}>
        {t('app.poweredBy')}
      </span>
      {/* The mark is dark navy, so on the brand surface it has to be knocked out
          to white — the same treatment the design gives the Conduril logo. */}
      <img
        src="/apexium-logo.png"
        alt="Apexium Systems"
        className={`w-auto ${dark ? 'h-[34px] brightness-0 invert' : 'h-[32px]'}`}
      />
    </a>
  );
}
